import { RefreshCw } from "lucide-react";
import { BottomNav } from "@/components/bottom-nav";
import { SideNav } from "@/components/side-nav";
import { Skeleton } from "@/components/ui/skeleton";

// The screens that used to render on the server now fetch on mount, so they
// need a first paint. This keeps the chrome (nav, page padding) identical to
// the loaded state so nothing shifts when the data lands.
function Shell({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SideNav />
      <div className="min-h-dvh lg:pl-64">
        <div className="mx-auto max-w-md px-4 pb-32 pt-[calc(env(safe-area-inset-top)+1.25rem)] lg:max-w-6xl lg:px-10 lg:pb-14 lg:pt-9">
          {children}
        </div>
      </div>
      <BottomNav />
    </>
  );
}

export function PageLoading() {
  return (
    <Shell>
      <div className="space-y-5">
        <Skeleton className="h-9 w-40" />
        <Skeleton className="h-11 w-full rounded-full" />
        <Skeleton className="h-44 w-full rounded-[1.75rem]" />
        <Skeleton className="h-32 w-full rounded-[1.75rem]" />
        <Skeleton className="h-32 w-full rounded-[1.75rem]" />
      </div>
    </Shell>
  );
}

export function PageError({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) {
  return (
    <Shell>
      <div className="mt-16 flex flex-col items-center gap-4 text-center">
        <div className="flex size-16 items-center justify-center rounded-3xl bg-card text-3xl shadow-sm ring-1 ring-black/[0.05]">
          ⚠️
        </div>
        <div>
          <p className="font-semibold">Couldn&apos;t load this page</p>
          <p className="mx-auto mt-1 max-w-xs text-sm text-muted-foreground">
            {message}
          </p>
        </div>
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex h-11 items-center gap-2 rounded-full bg-primary px-5 text-sm font-semibold text-primary-foreground transition-transform active:scale-[0.98]"
        >
          <RefreshCw className="size-4" />
          Try again
        </button>
      </div>
    </Shell>
  );
}
